import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import { FilterMatchMode } from "primereact/api";
import SalesPaymentsDialog from "../../components/Sale/SalesPaymentsDialog";
import SaleDetailDialog from "../../components/Sale/SaleDetailDialog";
import SaleReceipt from "../../components/Sale/SaleReceipt";
import SaleListService from "../../services/SaleListService";

const currency = new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" });
const fmtMoney = (v) => currency.format(v ?? 0);
const fmtDate = (isoOrDate) => (isoOrDate ? new Date(isoOrDate).toLocaleDateString("tr-TR") : "");

const statusOptions = [
  { label: "Tümü", value: null },
  { label: "Tam Ödendi", value: "Paid" },
  { label: "Kısmi Ödeme", value: "Partial" },
  { label: "Borçlu", value: "Unpaid" },
];

export default function SalesList() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);

  const receiptRef = useRef(null);
  const printMenuRef = useRef(null);
  const activeSaleIdRef = useRef(null);
  const [activeSaleId, setActiveSaleId] = useState(null);

  const [paymentsSaleId, setPaymentsSaleId] = useState(null);
  const [paymentsOpen, setPaymentsOpen] = useState(false);

  const [detailSaleId, setDetailSaleId] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);

  const openDetail = (saleId) => {
    setDetailSaleId(saleId);
    setDetailOpen(true);
  };

  const openPayments = (saleId) => {
  setPaymentsSaleId(saleId);
  setPaymentsOpen(true);
};
const refreshList = () => {
  fetchSales();
};
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [dateRange, setDateRange] = useState([new Date(), new Date()]); // [start, end]
  const [status, setStatus] = useState(null);
  const [global, setGlobal] = useState("");

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    customerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
const toLocalYMD = (d) => {
  if (!(d instanceof Date)) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
  const toast = useRef(null);

  const fetchSales = async () => {
    try {
      debugger;
      setLoading(true);
      const today = new Date();
      const [start, end] = dateRange || [];

      const params = {
        StartDate: toLocalYMD(start ?? today),
        EndDate: toLocalYMD(end ?? today),
      };

      // sadece varsa ekle
      if (status) {
        params.Status = status; // "Paid" | "Partial" | "Unpaid"
      }

 const res =  await SaleListService.getSales(params);
 if (res) {
    setRows(res);
 } 
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Hata",
        detail: err.message || "Satış listesi alınamadı.",
        life: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusBody = (row) => {
    const map = {
      Paid: { label: "Tam Ödendi", severity: "success" },
      Partial: { label: "Kısmi Ödeme", severity: "warning" },
      Unpaid: { label: "Borçlu", severity: "danger" },
    };
    const s = map[row.paymentStatus] || map.Unpaid;

    const types = {
      1: { label: "PEŞİN", color: "text-blue-600 bg-blue-50" },
      2: { label: "AÇIK HESAP", color: "text-purple-600 bg-purple-50" },
      3: { label: "VADELİ", color: "text-orange-600 bg-orange-50" }
    };
    const t = types[row.customerReceivableType] || { label: "BİLİNMİYOR", color: "text-slate-400 bg-slate-50" };

    return (
      <div className="flex flex-col items-center gap-1.5">
        <Tag value={s.label} severity={s.severity} rounded className="text-[9px]" />
        <span className={`font-black text-[9px] px-2 py-0.5 rounded-full ${t.color}`}>{t.label}</span>
      </div>
    );
  };

  const printMenuItems = [
    {
      label: 'Yazdırma Seçenekleri',
      items: [
        {
          label: 'Bilgi Fişi',
          icon: 'pi pi-print',
          command: () => receiptRef.current.print(activeSaleIdRef.current, 'info')
        },
        {
          label: 'Tahsilat Makbuzu',
          icon: 'pi pi-money-bill',
          command: () => receiptRef.current.print(activeSaleIdRef.current, 'collection')
        },
        {
          label: 'Detaylı Bilgi Fişi',
          icon: 'pi pi-file-pdf',
          command: () => receiptRef.current.print(activeSaleIdRef.current, 'detailed')
        }
      ]
    }
  ];

  return (
    <div className="p-4 md:p-6 space-y-6 bg-[#f8fafc] min-h-screen animate-fade-in">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />

      <div className="bg-white shadow-lg shadow-slate-200/50 border border-slate-200 rounded-2xl overflow-hidden no-print">
        {/* Modern Header / Filter Bar */}
        <div className="!bg-slate-300 border-b border-slate-200 px-4 py-4 md:px-6 md:py-5">
          <div className="flex flex-col xl:flex-row items-start xl:items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="bg-emerald-600 p-4  rounded-xl shadow-md shadow-emerald-500/20">
                <i className="pi pi-shopping-cart text-white text-lg"></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight">Satış Listesi</h1>
                <p className="text-slate-400 text-xs font-bold italic">Satış Hareketleri ve Ödemeler</p>
              </div>
            </div>

            <div className="flex flex-wrap items-end gap-4 w-full xl:w-auto mt-6 xl:mt-0">
              <div className="flex flex-col gap-1.5 flex-1 sm:flex-none">
                <label className="text-[10px] font-black text-slate-600 uppercase tracking-widest ml-1">Tarih Aralığı</label>
                <div className="bg-white p-1 rounded-xl border border-slate-200 shadow-sm flex items-center">
                  <Calendar
                    value={dateRange}
                    onChange={(e) => setDateRange(e.value ?? null)}
                    selectionMode="range"
                    readOnlyInput
                    showButtonBar
                    dateFormat="dd.mm.yy"
                    locale="tr"
                    placeholder="Tarih aralığı"
                    showIcon
                    className="w-full sm:w-64"
                    inputClassName="border-none py-1.5 font-bold text-slate-700 text-sm"
                    appendTo={document.body}
                  />
                </div>
              </div>

              <div className="flex flex-col gap-1.5 flex-1 sm:flex-none">
                <label className="text-[10px] font-black text-slate-600 uppercase tracking-widest ml-1">Ödeme Durumu</label>
                <div className="bg-white p-1 rounded-xl border border-slate-200 shadow-sm flex items-center">
                  <Dropdown
                    value={status}
                    options={statusOptions}
                    onChange={(e) => setStatus(e.value)}
                    placeholder="Tüm Durumlar"
                    className="w-full sm:w-48 border-none shadow-none font-bold text-slate-700 text-sm"
                    optionLabel="label"
                    optionValue="value"
                    showClear
                    appendTo="self"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-1.5 flex-1 md:w-64">
                <label className="text-[10px] font-black text-slate-600 uppercase tracking-widest ml-1">Hızlı Arama</label>
                <div className="relative">
                  <i className="pi pi-search absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-sm z-10"></i>
                  <InputText
                    value={global}
                    onChange={(e) => {
                      setGlobal(e.target.value);
                      setFilters((prev) => ({
                        ...prev,
                        global: { ...prev.global, value: e.target.value },
                      }));
                    }}
                    placeholder="Tabloda ara..."
                    className="w-full !pl-10 !py-2 bg-white border-slate-200 rounded-xl font-bold shadow-sm text-sm h-[42px]"
                  />
                </div>
              </div>

              <div className="flex items-center gap-2 mb-[2px]">
                <Button
                  icon="pi pi-filter"
                  label="FİLTRELE"
                  onClick={fetchSales}
                  className="!bg-emerald-600 border-none hover:!bg-emerald-700 px-6 h-[42px] rounded-xl font-black text-[11px] shadow-lg shadow-emerald-600/20 text-white transition-all active:scale-95"
                />
                <Button
                  icon="pi pi-refresh"
                  onClick={() => {
                    const t = new Date();
                    setDateRange([t, t]);
                    setStatus(null);
                    setGlobal("");
                    setFilters((f) => ({ ...f, global: { ...f.global, value: null } }));
                    fetchSales();
                  }}
                  className="p-button-text p-button-secondary bg-white border border-slate-200 rounded-xl w-[42px] h-[42px] p-0 flex items-center justify-center shadow-sm hover:bg-slate-50 transition-all active:rotate-180"
                  tooltip="Sıfırla"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="p-2 md:p-4">
          <DataTable
            value={rows}
            loading={loading}
            paginator
            rows={20}
            rowsPerPageOptions={[10, 20, 50, 100]}
            removableSort
            scrollable
            filters={filters}
            globalFilterFields={[
              "customerName",
              "grandTotal",
              "paidTotal",
              "balanceTotal",
              "saleDate",
            ]}
            sortField="saleDate"
            sortOrder={-1}
            className="p-datatable-sm"
            rowClassName={() => "hover:bg-slate-50/80 transition-colors"}
          >
            <Column
              field="saleDate"
              header="TARİH"
              body={(r) => (
                <div className="flex flex-col">
                   <span className="font-black text-slate-700">{fmtDate(r?.saleDate)}</span>
                   <span className="text-[10px] text-slate-400 font-bold uppercase tracking-tighter">İşlem Günü</span>
                </div>
              )}
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6"
              className="py-4 px-6"
            />
            <Column
              field="customerName"
              header="MÜŞTERİ"
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6"
              className="py-4 px-6"
              body={(r) => <span className="font-bold text-slate-600">{r.customerName}</span>}
            />
            <Column
              field="grandTotal"
              header="GENEL TOPLAM"
              body={(r) => <span className="font-black text-slate-800">{fmtMoney(r?.grandTotal)}</span>}
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-right"
              className="py-4 px-6"
              style={{ textAlign: 'right' }}
            />
            <Column
              field="paidTotal"
              header="TAHSİLAT"
              body={(r) => <span className="font-black text-emerald-600 bg-emerald-50 px-3 py-1 rounded-lg">{fmtMoney(r?.paidTotal)}</span>}
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-right"
              className="py-4 px-6"
              style={{ textAlign: 'right' }}
            />
            <Column
              field="balanceTotal"
              header="KALAN"
              body={(r) => (
                <span className={`font-black ${r?.balanceTotal > 0 ? 'text-red-500 bg-red-50' : 'text-slate-400 bg-slate-50'} px-3 py-1 rounded-lg`}>
                  {fmtMoney(r?.balanceTotal)}
                </span>
              )}
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-right"
              className="py-4 px-6"
              style={{ textAlign: 'right' }}
            />
            <Column
              field="dueDate"
              header="VADE TARİHİ"
              body={(r) => r.dueDate ? <span className="font-bold text-orange-600">{fmtDate(r.dueDate)}</span> : <span className="text-slate-300">-</span>}
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
              className="py-4 px-6"
              style={{ textAlign: 'center' }}
            />
            <Column
              header="DURUM"
              body={statusBody}
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
              className="py-4 px-6"
              style={{ textAlign: 'center' }}
            />
            <Column
              header="İŞLEMLER"
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-4 px-6 text-center"
              className="py-4 px-6"
              style={{ textAlign: 'center', width: 160 }}
              body={(row) => (
                  <div className="flex items-center justify-center gap-2 no-print">
                    <Button
                      icon="pi pi-print"
                      className="p-button-text p-button-success hover:bg-emerald-50 rounded-xl w-10 h-10 p-0"
                      tooltip="Yazdır"
                      tooltipOptions={{ position: 'top' }}
                      onClick={(e) => {
                        activeSaleIdRef.current = row.id;
                        setActiveSaleId(row.id); // Keep state for re-render if needed
                        printMenuRef.current.toggle(e);
                      }}
                    />
                    <Button
                      icon="pi pi-eye"
                      className="p-button-text p-button-secondary hover:bg-slate-100 rounded-xl w-10 h-10 p-0"
                      tooltip="Detay"
                      onClick={() => openDetail(row.id)}
                    />
                    <Button
                      icon="pi pi-wallet"
                      className="p-button-text p-button-info hover:bg-blue-50 rounded-xl w-10 h-10 p-0"
                      tooltip="Ödemeleri Gör"
                      onClick={() => openPayments(row.id)}
                    />
                  </div>
                )}
            />
          </DataTable>
        </div>
      </div>

      <SalesPaymentsDialog
        saleId={paymentsSaleId}
        visible={paymentsOpen}
        onHide={() => setPaymentsOpen(false)}
        onChanged={refreshList}
      />

      <SaleDetailDialog
        saleId={detailSaleId}
        visible={detailOpen}
        onHide={() => setDetailOpen(false)}
      />

      <Menu model={printMenuItems} popup ref={printMenuRef} appendTo={document.body} />
      <SaleReceipt ref={receiptRef} />
    </div>
  );
}
